import React from 'react'
import {SELFIE, ASSISTED} from '../../../enums/flow-type'

import './FlowStageChooseFlowType.scss'
import {useMyProfile} from '../../../hooks/useMyProfile'
import Div100Vh from 'react-div-100vh'

const FlowStageChooseFlowType = ({onFlowTypeSelected, onCancel}) => {
  const {profile} = useMyProfile();
  const selfieSelected = () => onFlowTypeSelected(SELFIE)
  const assistedSelected = () => onFlowTypeSelected(ASSISTED)
  const cancelSelected = () => onCancel()
  return (
    <Div100Vh className="flow-stage-choose-flow-type--container">
      <div>
        <p>Add a new Avatar for {profile ? profile.name : '--'}</p>
        <p>Select how you will take photos below</p>
      </div>
      <button className="large-button" onClick={selfieSelected}>
        <i/>
        <label>Selfie Mode</label>
      </button>
      <button className="large-button" onClick={assistedSelected}>
        <i/>
        <label>With a friend</label>
      </button>

      <button className="cancel" onClick={cancelSelected}>Cancel</button>
    </Div100Vh>
  )
}

export default FlowStageChooseFlowType